import React from 'react';
import { DevsoluxLogo } from '@/layout/DevsoluxLogo';
import { StyledToolElement } from './styles';

export const Logo = () => {
  return (
    <StyledToolElement title="JSON2Diagram">
      <DevsoluxLogo fontSize="1.2rem" hideText />
    </StyledToolElement>
  );
};
